/**
 * Enum representing the various states of a claim process.
 */
export enum ClaimStateTypes {
    /**
     * The claim is currently being validated.
     */
    validating = 'validating',

    /**
     * The claim is invalid.
     */
    invalid = 'invalid',

    /**
     * The claim is available for processing.
     */
    available = 'available',

    /**
     * The claim is available and the user is logged in.
     */
    availableLoggedIn = 'availableLoggedIn',

    /**
     * The claim is in the process of being minted.
     */
    minting = 'minting',

    /**
     * The claim has been successfully redeemed.
     */
    redeemed = 'redeemed',

    /**
     * The claim has been successfully redeemed.
     */
    redeemedCheckingSession = 'redeemedCheckingSession',

    /**
     * The claim has been successfully redeemed while the user is logged in.
     */
    redeemedLogin = 'redeemedLogin',
    
    /**
     * The claim has been successfully redeemed while the user is logged out.
     */
    redeemedLoggedout = 'redeemedLoggedout',

    /**
     * The claim has been redeemed while the user is logged in, but the claim is invalid.
     */
    redeemedLoggedInInvalid = 'redeemedLoggedInInvalid',

    /**
     * There was an error during the minting process.
     */
    mintingError = 'mintingError',

    /**
     * The user is currently logging in.
     */
    loggingIn = 'loggingIn',

    /**
     * An error occurred during the claim process.
     */
    error = 'error',
}

/**
 * Enum representing the various states of a user's login status.
 */
export enum LoginState {
    initialising = 'initialising',
    initialised = 'initialised',
    loggedIn = 'loggedIn',
    loggedOut = 'loggedOut',
}


/**
 * Enum representing different states of a campaign.
 */
export enum CampaignState {
    /**
     * The campaign is currently active and available.
     */
    available = 'available',

    /**
     * The campaign period has ended.
     */
    campaignOver = 'campaignOver',

    /**
     * The campaign period has not yet begun.
     */
    campaignNotBegun = 'campaignNotBegun',

    /**
     * No fan passes remain available for the campaign.
     */
    noFanPassesLeft = 'noFanPassesLeft',
}
